import { c as _c } from "react/compiler-runtime";
import Star from "@catchy/assets/svgs/star.svg";
export default function FavouriteIndicator(t0) {
  const $ = _c(5);
  const {
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const t2 = `mx-3 mt-px grid h-5 w-5 shrink-0 place-items-center text-orange-400 ${className}`;
  let t3;
  if ($[0] !== t2) {
    t3 = t2.trim();
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Star aria-hidden="true" className="size-5" />;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== t3) {
    t5 = <span aria-label="Favourite stop" className={t3} role="img">{t4}</span>;
    $[3] = t3;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  return t5;
}